import Messages from "@/pages/Messages";
export default function ProMessages() { return <Messages role="pro" />; }
